import { createFileRoute } from '@tanstack/react-router';
import { APP_PATHS, PAGE_PATHS } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/detections/settings/tickets-statuses/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({
      path: PAGE_PATHS.TICKETS_STATUSES,
      app: APP_PATHS.DETECTIONS,
    });
    context.validatePermissions({ isAllowed, preload });
  },
});
